const DEVICE_STATE_META = Object.freeze({
  Locked: { label: '已锁屏', tone: 'warning' },
  Disconnected: { label: '已断开', tone: 'danger' },
  Unavailable: { label: '服务异常', tone: 'danger' },
  Unknown: { label: '等待心跳', tone: 'muted' },
});

export const getJianyingDeviceSchedulingState = (device = {}) => {
  if (device.session_state === 'Ready' && device.is_online === true) {
    const capacity = Number(device.max_pending_jobs);
    const pending = Number(device.pending_job_count) || 0;
    if (capacity > 0 && pending >= capacity) {
      return { label: '积压已满', tone: 'warning', schedulable: false };
    }
    return { label: '可调度', tone: 'ready', schedulable: true };
  }
  if (device.session_state === 'Ready') {
    return { label: '心跳超时', tone: 'danger', schedulable: false };
  }
  const meta = DEVICE_STATE_META[device.session_state]
    || DEVICE_STATE_META.Unknown;
  return { ...meta, schedulable: false };
};

export const filterAndSortJianyingDevices = (
  devices,
  { filter = 'all', query = '' } = {},
) => {
  const normalizedQuery = String(query).trim().toLowerCase();
  return [...(Array.isArray(devices) ? devices : [])]
    .filter((device) => {
      const schedulable = getJianyingDeviceSchedulingState(device).schedulable;
      if (filter === 'ready' && !schedulable) return false;
      if (filter === 'attention' && schedulable) return false;
      if (!normalizedQuery) return true;
      return [device.name, device.id, device.platform].some((value) =>
        String(value || '').toLowerCase().includes(normalizedQuery));
    })
    .sort((left, right) =>
      Number(left.priority || 0) - Number(right.priority || 0)
      || String(left.name || '').localeCompare(String(right.name || ''), 'zh-CN'));
};

export const summarizeJianyingDevices = (devices, exporting = 0) => {
  const normalized = Array.isArray(devices) ? devices : [];
  const ready = normalized.filter(
    (device) => getJianyingDeviceSchedulingState(device).schedulable,
  ).length;
  return {
    ready,
    attention: normalized.length - ready,
    exporting: Number(exporting) || 0,
  };
};

export const getJianyingServiceStatus = (devices) => {
  const normalized = Array.isArray(devices) ? devices : [];
  const schedulableCount = normalized.filter(
    (device) => device.is_online === true,
  ).length;
  if (schedulableCount > 0) {
    return {
      label: `可用（${schedulableCount} 台）`,
      tone: 'success',
    };
  }
  const hasLiveHeartbeat = normalized.some(
    (device) =>
      device.heartbeat_alive === true || device.is_online === true,
  );
  if (hasLiveHeartbeat) {
    return { label: '在线但不可调度', tone: 'warning' };
  }
  return { label: '离线', tone: 'danger' };
};

export const buildJianyingTemplateCoverage = ({
  templates,
  devices,
  availabilityItems,
}) => {
  const normalizedDevices = Array.isArray(devices) ? devices : [];
  const availabilityByTemplate = new Map(
    (Array.isArray(availabilityItems) ? availabilityItems : [])
      .map((item) => [String(item.template_id), item]),
  );
  return (Array.isArray(templates) ? templates : []).map((template) => {
    const availability = availabilityByTemplate.get(String(template.id));
    const availableDeviceIds = new Set(
      Array.isArray(availability?.available_device_ids)
        ? availability.available_device_ids.map(String)
        : [],
    );
    const deviceStates = Object.fromEntries(normalizedDevices.map((device) => {
      const schedulable = getJianyingDeviceSchedulingState(device).schedulable;
      if (!schedulable) return [device.id, 'Ignored'];
      return [
        device.id,
        availableDeviceIds.has(String(device.id)) ? 'Available' : 'Unavailable',
      ];
    }));
    return {
      ...template,
      available: availability?.status === 'Available'
        && Object.values(deviceStates).includes('Available'),
      deviceStates,
    };
  });
};
